export const getPublicRoutes = () => {
  return [];
};
